<template>
  <div class="wrap_bottom wow fadeInUp">
    <div class="wrap_footer">
      <el-row>
        <el-col :span="7" class="header_block"></el-col>
        <el-col :span="10" class="header_block">
          <div class="wrap_block_title">
            <div class="block_title">微信 ：18610609955</div>
            <div class="block_title">电话 ：18610609955</div>
            <div class="block_title">邮箱 ：yankaijie@163.comm</div>
          </div>
          <img class="douyin_pic" :src="require('@/assets/imgs/douyin.png')" alt="alibaba" />
        </el-col>
        <el-col :span="7" class="header_block"></el-col>
      </el-row>
    </div>
    <p style="width:100%;text-align:center;color:#939393;margin:0 auto; padding:20px 0 10px 0;font-size:14px">Copyright © 2021.北京星沐互娱科技有限公司 All rights reserved.</p>
    <!-- <p
      style="width:100%;text-align:center;color:#939393;margin:0 auto; padding:10px 0;font-size:14px"
    >备案号: 京ICP备2021004656号-1</p> -->
    <div style="width:300px;text-align:center;color:#939393;margin:0 auto; padding:10px 0;" @click="goOut()">
      <a target="_blank"
        href="http://beian.miit.gov.cn/">
        <!--style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">-->
        <img :src="require('@/assets/imgs/beian.png')" style="float:left;" />
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;font-size:14px">备案号: 京ICP备2021004656号-1</p>
      </a>
    </div>
  </div>
</template>

<script>
// import titleBlock from '@/components/titleBlock.vue'

export default {
  name: "footerBlock",
  data() {
    return {
      fullYearTime: new Date().getFullYear()
    };
  },
    methods:{
      goOut(){
          window.open("http://beian.miit.gov.cn/","_blank")
      }
    },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live: true
      }).init();
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_footer {
  width: 100%;
  height: 282px;
  background: rgba(75, 75, 75, 1);
  .header_block {
    // text-align: center;
    min-height: 100px;
    // line-height: 100px;
    .wrap_block_title {
      width: 300px;
      height: 142px;
      margin-top: 70px;
      display: flex;
      flex-direction:column;
      justify-content:space-between;
      float: left;
      .block_title {
        width: 300px;
        color: #fff;
        font-size: 18px;
        // background: green;
      }
    }
  }
  .douyin_pic {
    margin-top: 70px;
    width: 142px;
    height: 142px;
    // margin: 0 auto;
    // display: inherit;
    float: right;
  }
}
</style>



